export function initScrollToTop() {

    // ==========================
// CONSTANTS
// ==========================
const SCROLL_THRESHOLD = 200; // Ab wann der Button eingeblendet wird (px)
const SCROLL_DURATION = 400;  // Dauer des Scrollens in ms

// ==========================
// GLOBAL VARIABLES
// ==========================
let scrollButton;

// ==========================
// FUNCTIONS
// ==========================

// Erstellt den Button und fügt ihn ins DOM ein
function createScrollToTopButton() {
  scrollButton = document.createElement('button');
  scrollButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 16 10"><path fill="#fff" fill-rule="nonzero" d="M7.067.317a1.19 1.19 0 0 1 1.617 0l6.75 6.75a1.19 1.19 0 0 1 0 1.617 1.19 1.19 0 0 1-1.617 0L7.875 2.707 1.934 8.684a1.19 1.19 0 0 1-1.617 0 1.19 1.19 0 0 1 0-1.617z"/></svg>';
  scrollButton.id = 'scrollToTopBtn';
  Object.assign(scrollButton.style, {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    width: '45px',
    height: '45px',
    backgroundColor: '#26594F',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    fontSize: '20px',
    cursor: 'pointer',
    opacity: '0',
    visibility: 'hidden',
    transition: 'opacity 0.3s ease, visibility 0.3s ease',
    zIndex: '1000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });
  const svgIcon = scrollButton.querySelector('svg');
  if (svgIcon) {
    Object.assign(svgIcon.style, {
      width: '40%',
      height: '100%',
      display: 'block',
      transformOrigin: 'center'
    });
  }

  document.body.appendChild(scrollButton);

  // Klick-Event für Smooth Scroll
  scrollButton.addEventListener('click', scrollToTop);
}

// Blendt den Button ein/aus
function toggleScrollButton() {
  if (window.scrollY > SCROLL_THRESHOLD) {
    scrollButton.style.opacity = '1';
    scrollButton.style.visibility = 'visible';
  } else {
    scrollButton.style.opacity = '0';
    scrollButton.style.visibility = 'hidden';
  }
}

// Scrollt sanft nach oben
function scrollToTop() {
  const start = window.scrollY;
  const startTime = performance.now();

  function animateScroll(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / SCROLL_DURATION, 1);
    const ease = 1 - Math.pow(1 - progress, 3); // Ease-out-Cubic
    window.scrollTo(0, start * (1 - ease));

    if (progress < 1) requestAnimationFrame(animateScroll);
  }

  requestAnimationFrame(animateScroll);
}



createScrollToTopButton();
window.addEventListener('scroll', toggleScrollButton);

  
}
